import React from 'react';
import { ThumbsUpIcon, MessageSquareIcon, ShareIcon, ChevronRightIcon, UserIcon, AlertCircleIcon } from 'lucide-react';
interface PostCardProps {
  post: {
    id: number;
    author: string;
    authorTitle: string;
    authorImage: string;
    date: string;
    content: string;
    likes: number;
    comments: number;
    shares: number;
  };
  onViewEngagement: (postId: number) => void;
  isSelected?: boolean;
  highIntentCount?: number;
  newEngagementCount?: number;
}
export const PostCard: React.FC<PostCardProps> = ({
  post,
  onViewEngagement,
  isSelected = false,
  highIntentCount = 0,
  newEngagementCount = 0
}) => {
  return <div className={`bg-white rounded-lg shadow-sm border p-4 mb-4 transition-all ${isSelected ? 'border-[#f9b30f] ring-2 ring-[#f9b30f] ring-opacity-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-849">
      <div className="flex items-center mb-3" data-id="element-850">
        <img src={post.authorImage} alt={post.author} className="w-10 h-10 rounded-full mr-3" data-id="element-851" />
        <div data-id="element-852">
          <div className="font-medium text-gray-900" data-id="element-853">{post.author}</div>
          <div className="text-sm text-gray-500" data-id="element-854">{post.authorTitle}</div>
        </div>
        <div className="ml-auto text-sm text-gray-500" data-id="element-855">{post.date}</div>
      </div>
      <div className="text-gray-800 mb-4 line-clamp-3" data-id="element-856">{post.content}</div>
      <div className="flex items-center justify-between pt-2 border-t border-gray-100" data-id="element-857">
        <div className="flex space-x-4" data-id="element-858">
          <div className="flex items-center text-gray-600" data-id="element-859">
            <ThumbsUpIcon size={16} className="mr-1" data-id="element-860" />
            <span className="text-sm" data-id="element-861">{post.likes}</span>
          </div>
          <div className="flex items-center text-gray-600" data-id="element-862">
            <MessageSquareIcon size={16} className="mr-1" data-id="element-863" />
            <span className="text-sm" data-id="element-864">{post.comments}</span>
          </div>
          <div className="flex items-center text-gray-600" data-id="element-865">
            <ShareIcon size={16} className="mr-1" data-id="element-866" />
            <span className="text-sm" data-id="element-867">{post.shares}</span>
          </div>
        </div>
        <button onClick={() => onViewEngagement(post.id)} className="flex items-center text-sm font-medium text-[#f9b30f] hover:text-[#e0a40e]" data-id="element-868">
          View Engagement
          <ChevronRightIcon size={16} className="ml-1" data-id="element-869" />
        </button>
      </div>
      {/* Intent Signals Indicators */}
      {(highIntentCount > 0 || newEngagementCount > 0) && <div className="mt-3 pt-2 border-t border-gray-100 flex flex-wrap gap-2" data-id="element-870">
          {highIntentCount > 0 && <div className="flex items-center px-2 py-1 bg-green-50 rounded-full text-xs font-medium text-green-700" data-id="element-871">
              <UserIcon size={12} className="mr-1" data-id="element-872" />
              {highIntentCount} high intent
            </div>}
          {newEngagementCount > 0 && <div className="flex items-center px-2 py-1 bg-purple-50 rounded-full text-xs font-medium text-purple-700" data-id="element-873">
              <AlertCircleIcon size={12} className="mr-1" data-id="element-874" />
              {newEngagementCount} new
            </div>}
        </div>}
    </div>;
};